<div 
  class="avatar-initials"
  [class]="sizeClass"
  [style.background-color]="backgroundColor"
  [attr.aria-label]="ariaLabel"
  role="img">
  {{ initials }}
</div>